module.exports = __webpack_public_path__ + "static/media/calendariocachureos.a3c4d03a.jpg";